define('collections/questionnaire/answers',[
    'underscore',
    'backbone',
    'utils',
    // services
    'services/api',
    // models
    'models/questionnaire/answer'
], function(
    _, Backbone, U,
    // services
    API,
    // models
    MAnswer
) {

    var CAnswers = Backbone.Collection.extend({
        model: MAnswer,

    });

    return CAnswers;

});

